import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  // plugins: [createPersistedState()],
  plugins: [
    createPersistedState({
      // paths: ['authfack'], // Only persist the 'user' state
      reducer: (state) => {
        const newState = { ...state };
        delete newState.integration; // Remove the 'integration' module
        delete newState.dashboard;
        return newState;
      },
    }),
  ],
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== "production",
});

export default store;
